import { render, staticRenderFns } from "./PemutakhiranMain.vue?vue&type=template&id=0e5def37&scoped=true&"
import script from "./PemutakhiranMain.vue?vue&type=script&lang=js&"
export * from "./PemutakhiranMain.vue?vue&type=script&lang=js&"
import style0 from "./PemutakhiranMain.vue?vue&type=style&index=0&id=0e5def37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5def37",
  null
  
)

export default component.exports